import React from 'react';
import { Link } from '@app/router';
import { chakra } from '@stockx/ui';
import { ConditionalWrapper } from '@app/ui';
import { useTranslation } from 'react-i18next';
import { Wordmark } from '@stockx/icons';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { usePageType } from '@app/page';

const LogoWrapper = chakra('span', {
  baseStyle: {
    display: 'block',
    marginLeft: { base: '0', md: 10 },
    marginRight: { base: '0', md: 10 },
  },
});

const HeadingWrapper = (
  children: React.ReactElement | React.ReactElement[],
) => {
  const { t } = useTranslation();
  return (
    <h1
      aria-label={t('Search for sneakers, streetwear, collectibles and more')}
    >
      {children}
    </h1>
  );
};

/**
 * @constructor
 */
const Logo = () => {
  const urlPrefix = useUrlPrefix();
  const { t } = useTranslation();
  const localizedLink =
    urlPrefix.length > 1 ? urlPrefix.slice(0, -1) : urlPrefix;

  const pageType = usePageType();

  return (
    <Link className="navbar-brand logo" to={localizedLink}>
      <ConditionalWrapper
        condition={pageType === 'Home'}
        wrapper={HeadingWrapper}
      >
        <LogoWrapper>
          <Wordmark
            width={{ base: '95px', md: '125px' }}
            title={t('stockx_logo')}
          />
        </LogoWrapper>
      </ConditionalWrapper>
    </Link>
  );
};

export default Logo;
